<template>
  <div>
    <v-card>
      <v-data-table
        v-model="tableValue"
        :headers="headers"
        :items="items"
        :rows-per-page-items="rowsPerPageItems"
        item-key="id"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.visits }}</td>
            <td>
              <v-icon
                small
                @click="$emit('delete', props.item)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          Create your first referral
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>


<script>
export default {
  name: 'referrals-table',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableValue: [],
      rowsPerPageItems: [5, 10, 20],
      headers: [
        {
          text: 'Referral',
          align: 'left',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Visits',
          align: 'left',
          sortable: true,
          value: 'visits',
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: null,
        },
      ],
    }
  },
}
</script>

<style>
</style>
